const msg = {
    confirm:
        "This operation will permanently delete data, do you want to continue?",
    tip: "tip",
    confirmText1: "OK",
    confirmText2: "Cancel",
    deleted: "Deleted successfully!",
    delete_fail: "Delete failed",
    undelete: "Undelete!",
    submit: "Added successfully!",
    submit2: "Edit successfully!",
    submit3: "Operation successful!",
    submit4: "Delete successful!",
    submit5: "Add failed!",
    submit6: "Edit failed!",
    submit7: "Operation failed!",
    submit8: "Delete failed!"
};

export default msg;
